import React from "react";
import { motion } from "framer-motion";
import { Reveal, Label } from "./anim";
import { EXPERTISE } from "../data/content";
import { Plus } from "lucide-react";

export const Expertise = () => {
  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="relative bg-[#E7E2D2] py-24 md:py-40 border-y border-[#16281C]/10"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <Label>Areas of Expertise</Label>
          <h2 className="mt-6 font-display font-semibold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] max-w-3xl text-[#16281C]">
            Full-lifecycle, multi-jurisdictional.
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 auto-rows-[minmax(180px,auto)] gap-4">
          {EXPERTISE.map((e, i) => (
            <motion.div
              key={e.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative flex flex-col justify-between bg-[#FAF8F1] border border-[#16281C]/12 p-7 md:p-8 hover:bg-[#2C5F3A] transition-colors duration-300 ${e.span}`}
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-[11px] tracking-[0.2em] text-[#8B978C] group-hover:text-[#EFEBDE]/70 transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <Plus size={18} className="text-[#8B978C] group-hover:text-[#EFEBDE] group-hover:rotate-90 transition-all duration-500" />
              </div>
              <div>
                <h3 className="font-display font-semibold text-xl md:text-2xl tracking-tight text-[#16281C] leading-tight group-hover:text-[#EFEBDE] transition-colors">
                  {e.title}
                </h3>
                <p className="mt-3 font-body text-sm md:text-base text-[#66766A] leading-relaxed group-hover:text-[#EFEBDE]/80 transition-colors">
                  {e.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
